import React from 'react';

function NotFound() {
  return (
    <p>NOT FOUND</p>

  );
}

export default NotFound;
